// src/components/menus/AccountsPageSubMenu.tsx
import React from 'react';
import {
  CompactSubMenuContainer,
  CompactSubMenuTab,
  SubMenuCap,
} from './shared/MenuElements';

interface TabItem {
  label: string;
  minWidth?: string;
}

interface AccountsPageSubMenuProps {
  tabs: TabItem[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

const AccountsPageSubMenu: React.FC<AccountsPageSubMenuProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <CompactSubMenuContainer>
      {tabs.map((tab, idx) => (
        <CompactSubMenuTab
          key={tab.label}
          isActive={activeTab === idx}
          minWidth={tab.minWidth}
          onClick={() => onTabChange(idx)}
          role="tab"
          aria-selected={activeTab === idx}
        >
          {tab.label}
        </CompactSubMenuTab>
      ))}
      <SubMenuCap height="3.4rem" />
    </CompactSubMenuContainer>
  );
};

export default AccountsPageSubMenu;
